import "./Gallery.css";
import { useState } from "react";
import { FaExpand, FaTimes } from "react-icons/fa";
import { PILLOW_COPY } from "../../content/pillowContent";

const galleryImages = [
  {
    src: "/images/gallery/pillow-1.png",
    title: "תמיכה בצוואר ובכתפיים",
    text: "נועדה לשחרר מתח ולפזר לחץ באזור הצוואר והכתפיים לאורך כל הלילה.",
  },
  {
    src: "/images/gallery/pillow-2.png",
    title: "חומר ויסקו איכותי",
    text: "מתאים את עצמו לצורת הצוואר והראש, לתמיכה יציבה ונעימה.",
  },
  {
    src: "/images/gallery/pillow-3.png",
    title: "עיצוב גלי ייחודי",
    text: "העיצוב הגלי שומר על יישור נכון של עמוד השדרה.",
  },
  {
    src: "/images/gallery/pillow-4.png",
    title: "לשינה על הגב ועל הצד",
    text: "מבנה ארגונומי שמותאם לשינה על הגב ועל הצד.",
  },
  {
    src: "/images/gallery/pillow-5.png",
    title: "שינה עמוקה ורגועה יותר",
    text: "תמיכה יציבה ונעימה לאורך כל הלילה.",
  },
  {
    src: "/images/gallery/pillow-6.png",
    title: "כרית ארגונומית Cervica",
    text: PILLOW_COPY.cta,
  },
];

function Gallery() {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <main className="gallery-page">
      <section className="gallery-hero">
        <span>גלריית תמונות</span>
        <h1>הכירו את Cervica מקרוב</h1>
        <p>
          הכירו את העיצוב הגלי הייחודי של כרית Cervica — כרית ארגונומית מחומר
          ויסקו איכותי, לשינה על הגב ועל הצד.
        </p>
      </section>

      <section className="photo-gallery-grid">
        {galleryImages.map((image, index) => (
          <div className="photo-card" key={index}>
            <div className="photo-image-box">
              <img src={image.src} alt={image.title} />

              <button
                type="button"
                className="photo-view-btn"
                aria-label={`הגדלת תמונה: ${image.title}`}
                onClick={() => setSelectedImage(image)}
              >
                <FaExpand aria-hidden="true" />
              </button>
            </div>

            <div className="photo-info">
              <h3>{image.title}</h3>
              <p>{image.text}</p>
            </div>
          </div>
        ))}
      </section>

      {selectedImage && (
        <div className="gallery-modal" onClick={() => setSelectedImage(null)}>
          <button
            type="button"
            className="modal-close"
            aria-label="סגירת התמונה"
            onClick={() => setSelectedImage(null)}
          >
            <FaTimes aria-hidden="true" />
          </button>

          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage.src} alt={selectedImage.title} />
            <h2>{selectedImage.title}</h2>
            <p>{selectedImage.text}</p>
          </div>
        </div>
      )}
    </main>
  );
}

export default Gallery;
